/**
 * Normalizes city names to a standard format (e.g., Mysore -> Mysuru).
 */
const CITY_NORMALIZATION_MAP: Record<string, string> = {
    'mysore': 'Mysuru',
    'bangalore': 'Bengaluru',
    'belgaum': 'Belagavi',
    'hubli': 'Hubballi',
    'mangalore': 'Mangaluru',
    'gulbarga': 'Kalaburagi',
    'bijapur': 'Vijayapura',
    'hospet': 'Hosapete',
    'shimoga': 'Shivamogga',
    'tumkur': 'Tumakuru',
    'chikmagalur': 'Chikkamagaluru',
    'bellary': 'Ballari',
};

export const normalizeCityName = (city: string | null | undefined): string | null | undefined => {
    if (!city) return city;
    
    const lowerCity = city.toLowerCase().trim();
    if (CITY_NORMALIZATION_MAP[lowerCity]) {
        return CITY_NORMALIZATION_MAP[lowerCity];
    }
    
    return city;
};
